var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg404(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 890,
    height: 531.909,
    viewBox: "0 0 890 531.909",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9633",
    "data-name": "Group 9633",
    transform: "translate(-339 -126)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9626",
    "data-name": "Group 9626",
    transform: "translate(-604.391 1398)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shadow",
    transform: "translate(949.744 -792.62)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_653",
    "data-name": "Ellipse 653",
    cx: 185.756,
    cy: 26.264,
    rx: 185.756,
    ry: 26.264,
    transform: "translate(0)",
    fill: "#ebebeb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_404_Error",
    "data-name": "404 Error",
    transform: "translate(943.391 -1272)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9557",
    "data-name": "Group 9557",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9555",
    "data-name": "Group 9555",
    transform: "translate(0 58.436)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11808",
    "data-name": "Path 11808",
    d: "M172.771,260.1l-7.738-30.445-61.11,15.531-8.077-31.778,48.836-111.3,24.223-6.156,23.551,92.667,19.556-4.97,8.133,32-19.556,4.97,7.738,30.445ZM130.9,204.265l30.222-7.68-10-39.334Z",
    transform: "translate(-95.846 -88.765)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11809",
    "data-name": "Path 11809",
    d: "M321.668,159.889a81.692,81.692,0,0,1-4.585,27.859A69.156,69.156,0,0,1,304.47,209.76,57.1,57.1,0,0,1,285.555,224.2a54.739,54.739,0,0,1-23.733,5.159,55.462,55.462,0,0,1-23.845-5.159,56.694,56.694,0,0,1-19.031-14.445,67.427,67.427,0,0,1-12.5-22.012,83.519,83.519,0,0,1-4.471-27.859,83.511,83.511,0,0,1,4.471-27.858,67.4,67.4,0,0,1,12.5-22.012,58.09,58.09,0,0,1,19.031-14.561,54.472,54.472,0,0,1,23.845-5.274,53.763,53.763,0,0,1,23.733,5.274A58.529,58.529,0,0,1,304.47,110.02a69.129,69.129,0,0,1,12.613,22.012A81.685,81.685,0,0,1,321.668,159.889Zm-36.916,0q0-16.046-6.42-26.025t-16.509-9.973q-10.549,0-16.851,9.973t-6.306,26.025q0,16.052,6.306,25.91t16.851,9.859q10.089,0,16.509-9.859T284.751,159.889Z",
    transform: "translate(-69.715 -90.185)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11810",
    "data-name": "Path 11810",
    d: "M362.147,253.807l5.023-31.008-62.242-10.083,5.243-32.367,89.114-82.655,24.671,4-15.291,94.382,19.918,3.228-5.28,32.592-19.918-3.226-5.023,31.008ZM345.97,185.916l30.781,4.987,6.491-40.062Z",
    transform: "translate(-44.368 -88.336)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9556",
    "data-name": "Group 9556",
    transform: "translate(123.19)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11811",
    "data-name": "Path 11811",
    d: "M212.116,79.622a16.248,16.248,0,0,1-7.123-1.535,17.469,17.469,0,0,1-5.487-4.078A18.912,18.912,0,0,1,194.7,61.5a17.96,17.96,0,0,1,1.335-6.847,18.893,18.893,0,0,1,3.674-5.789,17.541,17.541,0,0,1,5.563-4,16.517,16.517,0,0,1,7-1.484,15.684,15.684,0,0,1,7.073,1.585,17.671,17.671,0,0,1,5.462,4.152,19.144,19.144,0,0,1,3.524,5.841,18.379,18.379,0,0,1,1.259,6.645,18.106,18.106,0,0,1-1.309,6.822,18.571,18.571,0,0,1-3.625,5.739,17.418,17.418,0,0,1-5.538,3.977A16.5,16.5,0,0,1,212.116,79.622ZM201.745,61.5a14.337,14.337,0,0,0,.705,4.48,11.941,11.941,0,0,0,2.039,3.826,10.146,10.146,0,0,0,3.273,2.669,10.14,10.14,0,0,0,8.859-.026,10.114,10.114,0,0,0,3.273-2.744,12.2,12.2,0,0,0,2.014-3.85,14.29,14.29,0,0,0,.68-4.356,13.948,13.948,0,0,0-.73-4.48,12.384,12.384,0,0,0-2.065-3.827,9.845,9.845,0,0,0-3.271-2.642,10.2,10.2,0,0,0-8.836.05,9.95,9.95,0,0,0-3.271,2.719,12.192,12.192,0,0,0-1.989,3.826A14.287,14.287,0,0,0,201.745,61.5Z",
    transform: "translate(-194.698 -43.274)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11812",
    "data-name": "Path 11812",
    d: "M238.961,78.064a14.484,14.484,0,0,1-5.79-1.108,13.005,13.005,0,0,1-4.355-2.995,13.219,13.219,0,0,1-2.743-4.356,14.661,14.661,0,0,1,0-10.421,13.214,13.214,0,0,1,2.743-4.354,13.008,13.008,0,0,1,4.355-3,14.484,14.484,0,0,1,5.79-1.108,14.309,14.309,0,0,1,5.764,1.108,12.995,12.995,0,0,1,7.072,7.35,14.661,14.661,0,0,1,0,10.421,13.423,13.423,0,0,1-2.718,4.356,12.735,12.735,0,0,1-4.329,2.995A14.487,14.487,0,0,1,238.961,78.064Zm-6.9-13.644a9.179,9.179,0,0,0,.528,3.2,7.8,7.8,0,0,0,1.461,2.492,6.506,6.506,0,0,0,2.19,1.636,6.667,6.667,0,0,0,5.437,0,6.519,6.519,0,0,0,2.19-1.636,7.736,7.736,0,0,0,1.459-2.517,9.388,9.388,0,0,0,.53-3.221,9.252,9.252,0,0,0-.53-3.172,7.749,7.749,0,0,0-1.459-2.517,6.535,6.535,0,0,0-2.19-1.636,6.444,6.444,0,0,0-2.718-.578,6.2,6.2,0,0,0-2.719.6,6.855,6.855,0,0,0-2.19,1.661,7.764,7.764,0,0,0-1.461,2.517A9.252,9.252,0,0,0,232.064,64.42Z",
    transform: "translate(-187.209 -41.464)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11813",
    "data-name": "Path 11813",
    d: "M266.736,78.064a10.4,10.4,0,0,1-5.436-1.385,9.84,9.84,0,0,1-3.625-3.751V88.283h-6.746v-37.1h5.89v4.531a10.766,10.766,0,0,1,3.776-3.65,10.509,10.509,0,0,1,5.336-1.335,11.3,11.3,0,0,1,4.934,1.083,12.215,12.215,0,0,1,3.9,2.92,13.612,13.612,0,0,1,2.567,4.329,14.914,14.914,0,0,1,.931,5.261,16.651,16.651,0,0,1-.855,5.386,13.792,13.792,0,0,1-2.391,4.38,11.188,11.188,0,0,1-3.65,2.92A10.219,10.219,0,0,1,266.736,78.064Zm-2.264-5.739a6.053,6.053,0,0,0,2.794-.656,6.757,6.757,0,0,0,2.19-1.761,8.3,8.3,0,0,0,1.409-2.568,9.2,9.2,0,0,0,.5-3.02,8.531,8.531,0,0,0-.553-3.1,7.7,7.7,0,0,0-1.537-2.492,7.171,7.171,0,0,0-2.315-1.661,6.938,6.938,0,0,0-2.894-.6,6.333,6.333,0,0,0-1.964.327,6.924,6.924,0,0,0-1.863.932,8.151,8.151,0,0,0-1.535,1.409,5.868,5.868,0,0,0-1.032,1.762v6.191a8.969,8.969,0,0,0,2.768,3.751A6.336,6.336,0,0,0,264.472,72.325Z",
    transform: "translate(-180.853 -41.464)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11814",
    "data-name": "Path 11814",
    d: "M286.9,78.074a20.423,20.423,0,0,1-6.494-1.057A15.853,15.853,0,0,1,274.965,74l2.516-4.228a21.7,21.7,0,0,0,4.708,2.592,12.625,12.625,0,0,0,4.556.881,5.763,5.763,0,0,0,3.172-.755,2.433,2.433,0,0,0,1.158-2.165,2.163,2.163,0,0,0-1.36-2.064,29.23,29.23,0,0,0-4.43-1.51q-2.567-.7-4.38-1.36a11.221,11.221,0,0,1-2.919-1.485,5.068,5.068,0,0,1-1.611-1.913,6.1,6.1,0,0,1-.5-2.592,8.2,8.2,0,0,1,.78-3.625,7.9,7.9,0,0,1,2.19-2.744,10.135,10.135,0,0,1,3.3-1.736,13.388,13.388,0,0,1,4.1-.6,17.632,17.632,0,0,1,5.562.856,13.551,13.551,0,0,1,4.758,2.769l-2.719,4.078a15.808,15.808,0,0,0-3.9-2.216,10.652,10.652,0,0,0-3.749-.7,5.428,5.428,0,0,0-2.87.7,2.454,2.454,0,0,0-1.159,2.266,2.176,2.176,0,0,0,.278,1.158,2.416,2.416,0,0,0,.881.805,8.54,8.54,0,0,0,1.585.68q.983.329,2.441.679,2.718.707,4.657,1.411a12.688,12.688,0,0,1,3.172,1.61,5.761,5.761,0,0,1,1.813,2.089,6.454,6.454,0,0,1,.577,2.845,7.339,7.339,0,0,1-2.869,6.116A12.354,12.354,0,0,1,286.9,78.074Z",
    transform: "translate(-174.936 -41.474)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11815",
    "data-name": "Path 11815",
    d: "M297.667,65.949V43.294h6.746V65.949Zm0,13.442v-7.6h6.746v7.6Z",
    transform: "translate(-169.346 -43.294)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Robot",
    transform: "translate(978.254 -1077.753)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9600",
    "data-name": "Group 9600",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9558",
    "data-name": "Group 9558",
    transform: "translate(138.662 142.917)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3271",
    "data-name": "Rectangle 3271",
    width: 44.256,
    height: 3.625,
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3272",
    "data-name": "Rectangle 3272",
    width: 44.256,
    height: 3.625,
    transform: "translate(0 4.722)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3273",
    "data-name": "Rectangle 3273",
    width: 44.256,
    height: 3.625,
    transform: "translate(0 9.445)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3274",
    "data-name": "Rectangle 3274",
    width: 44.256,
    height: 3.625,
    transform: "translate(0 14.167)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3275",
    "data-name": "Rectangle 3275",
    width: 44.256,
    height: 3.625,
    transform: "translate(0 18.889)",
    fill: "#37474f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9559",
    "data-name": "Group 9559",
    transform: "translate(117.937 256.008)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3276",
    "data-name": "Rectangle 3276",
    width: 84.139,
    height: 3.625,
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3277",
    "data-name": "Rectangle 3277",
    width: 84.139,
    height: 3.625,
    transform: "translate(0 4.722)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3278",
    "data-name": "Rectangle 3278",
    width: 84.139,
    height: 3.625,
    transform: "translate(0 9.445)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3279",
    "data-name": "Rectangle 3279",
    width: 84.139,
    height: 3.625,
    transform: "translate(0 14.167)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3280",
    "data-name": "Rectangle 3280",
    width: 84.139,
    height: 3.625,
    transform: "translate(0 18.889)",
    fill: "#37474f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9571",
    "data-name": "Group 9571",
    transform: "translate(62.603)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9560",
    "data-name": "Group 9560",
    transform: "translate(0 37.611)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11816",
    "data-name": "Path 11816",
    d: "M192.473,304.682c.041-.49-18.417-6.672-18.417-6.672l1.09-63.415,24.474-5.252Z",
    transform: "translate(-174.056 -229.344)",
    fill: "#d87f07"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11817",
    "data-name": "Path 11817",
    d: "M192.473,304.682c.041-.49-18.417-6.672-18.417-6.672l1.09-63.415,24.474-5.252Z",
    transform: "translate(-174.056 -229.344)",
    fill: "#d87f07",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9561",
    "data-name": "Group 9561",
    transform: "translate(187.471 64.643)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11818",
    "data-name": "Path 11818",
    d: "M324.489,324.233c.13-.474,19.588.072,19.588.072l20.8-59.917L343.7,251.036Z",
    transform: "translate(-324.489 -251.036)",
    fill: "#d87f07"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11819",
    "data-name": "Path 11819",
    d: "M324.489,324.233c.13-.474,19.588.072,19.588.072l20.8-59.917L343.7,251.036Z",
    transform: "translate(-324.489 -251.036)",
    fill: "#d87f07",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_11820",
    "data-name": "Path 11820",
    d: "M185.983,335.464s6.843-102.561,12.845-136.3c0,0,123.893,9.37,190.777,34.935,0,0-34.483,119.794-36.266,125.74C353.339,359.839,266.094,342.653,185.983,335.464Z",
    transform: "translate(-171.119 -199.164)",
    fill: "#fa9001"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9562",
    "data-name": "Group 9562",
    transform: "translate(105.864 13.697)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11821",
    "data-name": "Path 11821",
    d: "M277.394,210.155q-3.021,18.523-6.162,37.026l-6.386,36.986-.345-.523,41.512,9.863,20.734,5.025,20.711,5.124L326.638,299l-20.8-4.758-41.55-9.706-.42-.1.076-.425,6.611-36.946Q273.893,228.594,277.394,210.155Z",
    transform: "translate(-257.807 -210.155)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11822",
    "data-name": "Path 11822",
    d: "M272.019,216.281a2.424,2.424,0,0,1-2.176,2.408,2.42,2.42,0,1,1,0-4.818A2.425,2.425,0,0,1,272.019,216.281Zm0,0a1.943,1.943,0,0,0-2.176-1.94,1.957,1.957,0,0,0,0,3.883,1.943,1.943,0,0,0,2.176-1.943Z",
    transform: "translate(-256.987 -209.243)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11823",
    "data-name": "Path 11823",
    d: "M270.273,228.526a2.423,2.423,0,0,1-2.175,2.409,2.421,2.421,0,1,1,0-4.819A2.425,2.425,0,0,1,270.273,228.526Zm0,0a1.941,1.941,0,0,0-2.175-1.94,1.958,1.958,0,0,0,0,3.884,1.945,1.945,0,0,0,2.175-1.944Z",
    transform: "translate(-257.417 -206.228)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11824",
    "data-name": "Path 11824",
    d: "M268.123,241.465a2.422,2.422,0,0,1-2.175,2.408,2.42,2.42,0,1,1,0-4.818A2.424,2.424,0,0,1,268.123,241.465Zm0,0a1.941,1.941,0,0,0-2.175-1.94,1.957,1.957,0,0,0,0,3.883,1.979,1.979,0,0,0,1.492-.45A2,2,0,0,0,268.123,241.465Z",
    transform: "translate(-257.946 -203.042)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11825",
    "data-name": "Path 11825",
    d: "M265.973,254.4a2.422,2.422,0,0,1-2.175,2.408,2.42,2.42,0,1,1,0-4.818A2.423,2.423,0,0,1,265.973,254.4Zm0,0a1.941,1.941,0,0,0-2.175-1.94,1.957,1.957,0,0,0,0,3.883,1.945,1.945,0,0,0,2.175-1.943Z",
    transform: "translate(-258.476 -199.856)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11826",
    "data-name": "Path 11826",
    d: "M273.3,275.039a2.424,2.424,0,0,1-2.176,2.408,2.42,2.42,0,1,1,0-4.818A2.425,2.425,0,0,1,273.3,275.039Zm0,0a1.943,1.943,0,0,0-2.176-1.94,1.957,1.957,0,0,0,0,3.883,1.945,1.945,0,0,0,2.176-1.943Z",
    transform: "translate(-256.672 -194.776)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11827",
    "data-name": "Path 11827",
    d: "M285.512,278.018a2.422,2.422,0,0,1-2.176,2.408,2.42,2.42,0,1,1,0-4.818A2.424,2.424,0,0,1,285.512,278.018Zm0,0a1.941,1.941,0,0,0-2.176-1.94,1.957,1.957,0,0,0,0,3.883,1.981,1.981,0,0,0,1.493-.45A2,2,0,0,0,285.512,278.018Z",
    transform: "translate(-253.665 -194.042)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11828",
    "data-name": "Path 11828",
    d: "M297.726,281a2.424,2.424,0,0,1-2.176,2.408,2.421,2.421,0,1,1,0-4.819A2.427,2.427,0,0,1,297.726,281Zm0,0a2,2,0,0,0-.684-1.493,1.985,1.985,0,0,0-1.492-.449,1.958,1.958,0,0,0,0,3.884A1.945,1.945,0,0,0,297.726,281Z",
    transform: "translate(-250.658 -193.309)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11829",
    "data-name": "Path 11829",
    d: "M309.939,283.977a2.423,2.423,0,0,1-2.176,2.408,2.42,2.42,0,1,1,0-4.818A2.425,2.425,0,0,1,309.939,283.977Zm0,0a1.941,1.941,0,0,0-2.176-1.94,1.957,1.957,0,0,0,0,3.883,1.945,1.945,0,0,0,2.176-1.943Z",
    transform: "translate(-247.651 -192.575)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11830",
    "data-name": "Path 11830",
    d: "M322.145,287.126a2.423,2.423,0,0,1-2.354,2.234,2.42,2.42,0,1,1,.371-4.8A2.424,2.424,0,0,1,322.145,287.126Zm0,0a1.942,1.942,0,0,0-2.019-2.1,1.958,1.958,0,0,0-.3,3.872,1.942,1.942,0,0,0,2.318-1.77Z",
    transform: "translate(-244.643 -191.845)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11831",
    "data-name": "Path 11831",
    d: "M263.823,267.343a2.422,2.422,0,0,1-2.175,2.408,2.42,2.42,0,1,1,0-4.818A2.423,2.423,0,0,1,263.823,267.343Zm0,0a1.941,1.941,0,0,0-2.175-1.942,1.958,1.958,0,0,0,0,3.884,1.945,1.945,0,0,0,2.175-1.943Z",
    transform: "translate(-259.005 -196.671)",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9569",
    "data-name": "Group 9569",
    transform: "translate(11.85 35.238)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9564",
    "data-name": "Group 9564",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_654",
    "data-name": "Ellipse 654",
    cx: 35.182,
    cy: 35.182,
    r: 35.182,
    transform: "translate(0 47.047) rotate(-41.961)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_655",
    "data-name": "Ellipse 655",
    cx: 28.216,
    cy: 28.216,
    r: 28.216,
    transform: "translate(13.308 66.085) rotate(-69.267)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9563",
    "data-name": "Group 9563",
    transform: "translate(30.535 30.598)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3281",
    "data-name": "Rectangle 3281",
    width: 6.682,
    height: 6.682,
    transform: "translate(10.847 7.665) rotate(9.202)",
    fill: "#ffa52c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3282",
    "data-name": "Rectangle 3282",
    width: 6.682,
    height: 6.682,
    transform: "translate(5.319 0) rotate(9.202)",
    fill: "#ffa52c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3283",
    "data-name": "Rectangle 3283",
    width: 6.682,
    height: 6.682,
    transform: "translate(31.704 4.275) rotate(9.202)",
    fill: "#ffa52c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3284",
    "data-name": "Rectangle 3284",
    width: 6.682,
    height: 6.682,
    transform: "translate(1.069 26.236) rotate(9.202)",
    fill: "#ffa52c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3285",
    "data-name": "Rectangle 3285",
    width: 6.682,
    height: 6.682,
    transform: "translate(27.453 30.511) rotate(9.202)",
    fill: "#ffa52c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3286",
    "data-name": "Rectangle 3286",
    width: 6.682,
    height: 6.682,
    transform: "translate(8.733 20.708) rotate(9.202)",
    fill: "#ffa52c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3287",
    "data-name": "Rectangle 3287",
    width: 6.682,
    height: 6.682,
    transform: "translate(16.386 15.255) rotate(9.202)",
    fill: "#ffa52c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3288",
    "data-name": "Rectangle 3288",
    width: 6.682,
    height: 6.682,
    transform: "translate(24.039 9.802) rotate(9.202)",
    fill: "#ffa52c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3289",
    "data-name": "Rectangle 3289",
    width: 6.682,
    height: 6.682,
    transform: "translate(21.926 22.846) rotate(9.203)",
    fill: "#ffa52c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9568",
    "data-name": "Group 9568",
    transform: "translate(94.583 14.917)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9565",
    "data-name": "Group 9565",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_656",
    "data-name": "Ellipse 656",
    cx: 35.182,
    cy: 35.182,
    r: 35.182,
    transform: "translate(0 54.425) rotate(-50.667)",
    fill: "#fa9001"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_657",
    "data-name": "Ellipse 657",
    cx: 35.182,
    cy: 35.182,
    r: 35.182,
    transform: "translate(0 54.425) rotate(-50.667)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11832",
    "data-name": "Path 11832",
    d: "M340.318,294.233c-.162.693-.346,1.362-.555,2.031l-68.576-14.627c.162-1.224.381-2.448.67-3.683a35.185,35.185,0,1,1,68.461,16.278Z",
    transform: "translate(-256.575 -236.58)",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_658",
    "data-name": "Ellipse 658",
    cx: 28.216,
    cy: 28.216,
    r: 28.216,
    transform: "translate(12.6 34.355) rotate(-22.676)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9566",
    "data-name": "Group 9566",
    transform: "translate(42.416 32.56)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3290",
    "data-name": "Rectangle 3290",
    width: 6.682,
    height: 33.26,
    transform: "translate(7.69 0) rotate(13.369)",
    fill: "#ffa52c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9567",
    "data-name": "Group 9567",
    transform: "translate(13.752 11.412)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11833",
    "data-name": "Path 11833",
    d: "M342.529,294.146,270.5,277.028a37.019,37.019,0,0,1,72.032,17.118Z",
    transform: "translate(-270.497 -248.568)",
    fill: "#fa9001"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11834",
    "data-name": "Path 11834",
    d: "M342.529,294.146,270.5,277.028a37.019,37.019,0,0,1,72.032,17.118Z",
    transform: "translate(-271.497 -248.568)",
    opacity: 0.2
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_11835",
    "data-name": "Path 11835",
    d: "M250.071,298.107a13.03,13.03,0,0,1,3.255-7.921,9.533,9.533,0,0,1,3.825-2.573,10.755,10.755,0,0,1,4.612-.512,8.584,8.584,0,0,1,7.229,5.4,14.41,14.41,0,0,1,.734,8.534,22.578,22.578,0,0,0-2.48-7.648,7.323,7.323,0,0,0-5.75-3.813,8.733,8.733,0,0,0-6.834,2A18.468,18.468,0,0,0,250.071,298.107Z",
    transform: "translate(-167.19 -212.764)",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9570",
    "data-name": "Group 9570",
    transform: "translate(24.5 2.965)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11836",
    "data-name": "Path 11836",
    d: "M193.716,247.4c.293-3.76.714-7.5,1.07-11.25.4-3.744.811-7.486,1.267-11.221.432-3.74.92-7.471,1.4-11.2s1.009-7.457,1.512-11.187l.133-1,1.009.064q12.179.766,24.307,2,6.066.622,12.116,1.4c4.026.578,8.059,1.112,12.062,1.844l-24.322-1.505-24.3-1.573,1.143-.932c-.552,3.722-1.064,7.45-1.65,11.167s-1.142,7.439-1.763,11.151c-.6,3.716-1.24,7.425-1.893,11.134C195.109,240,194.477,243.707,193.716,247.4Z",
    transform: "translate(-193.716 -201.543)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11837",
    "data-name": "Path 11837",
    d: "M198.411,266.2a30.732,30.732,0,0,1,5.629-12.574c.687-.942,1.468-1.814,2.221-2.712.813-.839,1.659-1.651,2.495-2.476.91-.74,1.829-1.474,2.764-2.186.994-.629,1.974-1.286,2.985-1.891,1.063-.511,2.12-1.038,3.193-1.523l3.342-1.157,3.459-.714c1.161-.169,2.342-.206,3.507-.293a33.9,33.9,0,0,1,13.545,2.6,48.211,48.211,0,0,0-13.434-.891,31.594,31.594,0,0,0-12.553,3.9,36.639,36.639,0,0,0-10.191,8.411A41.5,41.5,0,0,0,198.411,266.2Z",
    transform: "translate(-192.56 -191.911)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11838",
    "data-name": "Path 11838",
    d: "M276.287,273.008a30.709,30.709,0,0,1,7.31-11.676c.81-.84,1.7-1.6,2.573-2.379.921-.719,1.872-1.407,2.814-2.109,1-.607,2.015-1.208,3.039-1.783,1.072-.486,2.132-1,3.216-1.461,1.124-.359,2.243-.735,3.372-1.067l3.471-.684,3.526-.229c1.173-.009,2.347.12,3.513.193a33.914,33.914,0,0,1,13.057,4.441A48.217,48.217,0,0,0,309,253.518a31.586,31.586,0,0,0-12.971,2.125,36.651,36.651,0,0,0-11.256,6.923A41.478,41.478,0,0,0,276.287,273.008Z",
    transform: "translate(-173.386 -189.214)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9590",
    "data-name": "Group 9590",
    transform: "translate(13.285 89.125)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9574",
    "data-name": "Group 9574"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9572",
    "data-name": "Group 9572",
    transform: "translate(15.322 29.374)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11839",
    "data-name": "Path 11839",
    d: "M199.571,375.256c-9.013,0-28.741-2.026-41.438-18.35-16.243-20.884-10.373-60.957-10.115-62.653l7.052,1.072c-.059.385-5.664,38.745,8.694,57.2,14.036,18.046,39.495,15.455,39.749,15.424l.8,7.087A44.607,44.607,0,0,1,199.571,375.256Z",
    transform: "translate(-146.777 -294.252)",
    fill: "#fdaa3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11840",
    "data-name": "Path 11840",
    d: "M199.571,375.256c-9.013,0-28.741-2.026-41.438-18.35-16.243-20.884-10.373-60.957-10.115-62.653l7.052,1.072c-.059.385-5.664,38.745,8.694,57.2,14.036,18.046,39.495,15.455,39.749,15.424l.8,7.087A44.607,44.607,0,0,1,199.571,375.256Z",
    transform: "translate(-146.777 -294.252)",
    fill: "#fdaa3c",
    opacity: 0.4
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_11841",
    "data-name": "Path 11841",
    d: "M160.173,305.979a24.584,24.584,0,0,1-3.937-.324c-11.9-1.927-17.163-9.045-19.487-14.678s-2.868-12.475-1.6-20.3l15.087,2.444c-.785,4.846-.557,9.116.642,12.023.855,2.074,2.515,4.562,7.8,5.42,2.415.391,5.025.184,7.76-3.941a28.5,28.5,0,0,0,3.822-10.258l15.087,2.444a44.166,44.166,0,0,1-6.171,16.261C174.454,302.2,167.806,305.979,160.173,305.979Z",
    transform: "translate(-134.482 -270.681)",
    fill: "#fa9001"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9573",
    "data-name": "Group 9573",
    transform: "translate(64.048 80.697)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11842",
    "data-name": "Path 11842",
    d: "M204.848,385.53c-.026-.325-12.781-2.363-12.781-2.363l-6.191-41.631,15.449-6.1Z",
    transform: "translate(-185.876 -335.435)",
    fill: "#c87301"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11843",
    "data-name": "Path 11843",
    d: "M204.848,385.53c-.026-.325-12.781-2.363-12.781-2.363l-6.191-41.631,15.449-6.1Z",
    transform: "translate(-185.876 -335.435)",
    fill: "#c87301",
    opacity: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9575",
    "data-name": "Group 9575",
    transform: "translate(209.132 80.864)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11844",
    "data-name": "Path 11844",
    d: "M302.3,385.574c.034-.325,12.831-2.08,12.831-2.08l7.11-41.484-15.311-6.442Z",
    transform: "translate(-302.296 -335.569)",
    fill: "#d87f07"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11845",
    "data-name": "Path 11845",
    d: "M302.3,385.574c.034-.325,12.831-2.08,12.831-2.08l7.11-41.484-15.311-6.442Z",
    transform: "translate(-302.296 -335.569)",
    fill: "#d87f07",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_11846",
    "data-name": "Path 11846",
    d: "M196.841,328.272s103.169-4.412,138.019,1.4c0,0-10.234,99.829-10.787,101.766,0,0-102.627-.277-118.669,0C205.4,431.434,196.709,365.053,196.841,328.272Z",
    transform: "translate(-119.128 -256.897)",
    fill: "#fa9001"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9586",
    "data-name": "Group 9586",
    transform: "translate(109.046 97.922)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11847",
    "data-name": "Path 11847",
    d: "M221.987,350.066s56.32-2.224,75.345.7c0,0-5.587,50.339-5.888,51.315,0,0-56.025-.14-64.783,0C226.66,402.085,222.812,367.632,221.987,350.066Z",
    transform: "translate(-221.983 -349.257)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11848",
    "data-name": "Path 11848",
    d: "M229.686,401.929c-1.289,0-2.312.016-3.027.025,0,0-3.843-34.459-4.675-52.026,0,0,1.281-.05,3.518-.125Z",
    transform: "translate(-221.984 -349.122)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9580",
    "data-name": "Group 9580",
    transform: "translate(6.855 3.591)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9579",
    "data-name": "Group 9579"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9578",
    "data-name": "Group 9578"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9577",
    "data-name": "Group 9577"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11849",
    "data-name": "Path 11849",
    d: "M244.345,361.239a5.991,5.991,0,1,0,3.909,7.515A5.99,5.99,0,0,0,244.345,361.239Zm3.215,7.294a5.259,5.259,0,1,1-3.432-6.595A5.258,5.258,0,0,1,247.56,368.533Zm-3.215-7.294a5.991,5.991,0,1,0,3.909,7.515A5.99,5.99,0,0,0,244.345,361.239Zm3.215,7.294a5.259,5.259,0,1,1-3.432-6.595A5.258,5.258,0,0,1,247.56,368.533Zm-3.215-7.294a5.991,5.991,0,1,0,3.909,7.515A5.99,5.99,0,0,0,244.345,361.239Zm3.215,7.294a5.259,5.259,0,1,1-3.432-6.595A5.258,5.258,0,0,1,247.56,368.533Zm-1.219-13.622a12.626,12.626,0,1,0,8.242,15.836A12.63,12.63,0,0,0,246.341,354.911Zm2.8,14.121a6.92,6.92,0,1,1-4.519-8.679A6.929,6.929,0,0,1,249.145,369.032Zm-.891-.278a5.989,5.989,0,1,0-7.508,3.913A5.991,5.991,0,0,0,248.254,368.754Zm-.694-.221a5.259,5.259,0,1,1-3.432-6.595A5.258,5.258,0,0,1,247.56,368.533Zm-3.215-7.294a5.991,5.991,0,1,0,3.909,7.515A5.99,5.99,0,0,0,244.345,361.239Zm3.215,7.294a5.259,5.259,0,1,1-3.432-6.595A5.258,5.258,0,0,1,247.56,368.533Zm-3.215-7.294a5.991,5.991,0,1,0,3.909,7.515A5.99,5.99,0,0,0,244.345,361.239Zm3.215,7.294a5.259,5.259,0,1,1-3.432-6.595A5.258,5.258,0,0,1,247.56,368.533Z",
    transform: "translate(-226.886 -351.601)",
    fill: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9576",
    "data-name": "Group 9576"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11850",
    "data-name": "Path 11850",
    d: "M240.056,374.593l-4.63-1.459-.777,3.358,4.118,1.3Z",
    transform: "translate(-225.72 -346.97)",
    fill: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11851",
    "data-name": "Path 11851",
    d: "M233.331,371.676l-2.242-4.306-2.924,1.825,1.994,3.83Z",
    transform: "translate(-227.317 -348.389)",
    fill: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11852",
    "data-name": "Path 11852",
    d: "M230.681,364.711l1.459-4.63-3.358-.777-1.3,4.118Z",
    transform: "translate(-227.484 -350.375)",
    fill: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11853",
    "data-name": "Path 11853",
    d: "M233.8,357.986l4.306-2.242-1.825-2.924-3.83,1.994Z",
    transform: "translate(-226.263 -351.971)",
    fill: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11854",
    "data-name": "Path 11854",
    d: "M240.712,355.336l4.63,1.459.777-3.358-4.118-1.3Z",
    transform: "translate(-224.228 -352.139)",
    fill: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11855",
    "data-name": "Path 11855",
    d: "M247.39,358.451l2.242,4.306,2.924-1.825-1.995-3.83Z",
    transform: "translate(-222.584 -350.917)",
    fill: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11856",
    "data-name": "Path 11856",
    d: "M249.939,365.367,248.48,370l3.358.777,1.3-4.118Z",
    transform: "translate(-222.315 -348.882)",
    fill: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11857",
    "data-name": "Path 11857",
    d: "M247.021,372.044l-4.306,2.242,1.825,2.924,3.83-1.994Z",
    transform: "translate(-223.734 -347.238)",
    fill: "#e4e4e4"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9585",
    "data-name": "Group 9585",
    transform: "translate(31.886 23.804)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9584",
    "data-name": "Group 9584"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9583",
    "data-name": "Group 9583"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9582",
    "data-name": "Group 9582"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11858",
    "data-name": "Path 11858",
    d: "M259.949,375.024a4.033,4.033,0,1,0,1.176,5.581A4.034,4.034,0,0,0,259.949,375.024Zm.766,5.311a3.541,3.541,0,1,1-1.034-4.9A3.54,3.54,0,0,1,260.716,380.335Zm-.766-5.311a4.033,4.033,0,1,0,1.176,5.581A4.034,4.034,0,0,0,259.949,375.024Zm.766,5.311a3.541,3.541,0,1,1-1.034-4.9A3.54,3.54,0,0,1,260.716,380.335Zm-.766-5.311a4.033,4.033,0,1,0,1.176,5.581A4.034,4.034,0,0,0,259.949,375.024Zm.766,5.311a3.541,3.541,0,1,1-1.034-4.9A3.54,3.54,0,0,1,260.716,380.335Zm1.672-9.054a8.5,8.5,0,1,0,2.482,11.759A8.5,8.5,0,0,0,262.388,371.281Zm-.735,9.664a4.659,4.659,0,1,1-1.361-6.445A4.664,4.664,0,0,1,261.653,380.946Zm-.527-.341a4.032,4.032,0,1,0-5.577,1.18A4.034,4.034,0,0,0,261.126,380.6Zm-.41-.269a3.541,3.541,0,1,1-1.034-4.9A3.54,3.54,0,0,1,260.716,380.335Zm-.766-5.311a4.033,4.033,0,1,0,1.176,5.581A4.034,4.034,0,0,0,259.949,375.024Zm.766,5.311a3.541,3.541,0,1,1-1.034-4.9A3.54,3.54,0,0,1,260.716,380.335Zm-.766-5.311a4.033,4.033,0,1,0,1.176,5.581A4.034,4.034,0,0,0,259.949,375.024Zm.766,5.311a3.541,3.541,0,1,1-1.034-4.9A3.54,3.54,0,0,1,260.716,380.335Z",
    transform: "translate(-247.158 -367.977)",
    fill: "#dbdbdb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9581",
    "data-name": "Group 9581"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11859",
    "data-name": "Path 11859",
    d: "M254.361,383.271l-2.739-1.783-1.111,2.037,2.436,1.586Z",
    transform: "translate(-246.847 -365.125)",
    fill: "#dbdbdb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11860",
    "data-name": "Path 11860",
    d: "M250.472,380.086l-.676-3.2-2.226.655.6,2.844Z",
    transform: "translate(-247.571 -366.257)",
    fill: "#dbdbdb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11861",
    "data-name": "Path 11861",
    d: "M250.1,375.148l1.783-2.739-2.037-1.111-1.586,2.436Z",
    transform: "translate(-247.402 -367.634)",
    fill: "#dbdbdb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11862",
    "data-name": "Path 11862",
    d: "M253.256,371.26l3.2-.676-.655-2.226-2.844.6Z",
    transform: "translate(-246.245 -368.358)",
    fill: "#dbdbdb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11863",
    "data-name": "Path 11863",
    d: "M258.263,370.882,261,372.666l1.111-2.037-2.436-1.586Z",
    transform: "translate(-244.938 -368.189)",
    fill: "#dbdbdb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11864",
    "data-name": "Path 11864",
    d: "M261.964,374.043l.676,3.2,2.226-.655-.6-2.844Z",
    transform: "translate(-244.027 -367.032)",
    fill: "#dbdbdb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11865",
    "data-name": "Path 11865",
    d: "M262.483,379.05l-1.783,2.739,2.037,1.111,1.586-2.436Z",
    transform: "translate(-244.338 -365.725)",
    fill: "#dbdbdb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11866",
    "data-name": "Path 11866",
    d: "M259.3,382.751l-3.2.676.655,2.226,2.844-.6Z",
    transform: "translate(-245.47 -364.814)",
    fill: "#dbdbdb"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9588",
    "data-name": "Group 9588",
    transform: "translate(178.506 86.028)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11867",
    "data-name": "Path 11867",
    d: "M305.595,416.605l3.964.738,11.34-76.8-4.518-.83Z",
    transform: "translate(-270.858 -339.713)",
    fill: "#fa9001"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9587",
    "data-name": "Group 9587"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11868",
    "data-name": "Path 11868",
    d: "M277.721,404.435l5.888-51.315,39.634-13.407s-10.787,77.722-10.787,76.892Z",
    transform: "translate(-277.721 -339.713)",
    fill: "#fcaa3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11869",
    "data-name": "Path 11869",
    d: "M277.721,404.435l5.888-51.315,39.634-13.407s-10.787,77.722-10.787,76.892Z",
    transform: "translate(-277.721 -339.713)",
    fill: "#fcaa3c",
    opacity: 0.4
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_11870",
    "data-name": "Path 11870",
    d: "M200.943,357.786c-.646-4.251-.994-8.537-1.26-12.826-.121-2.145-.176-4.293-.224-6.443s-.08-4.3-.016-6.448l.017-.566.55-.029c7.874-.422,15.742-.941,23.619-1.285,7.876-.389,15.753-.741,23.634-.988-7.856.712-15.718,1.317-23.582,1.888-7.86.614-15.731,1.056-23.6,1.591l.567-.594-.032,6.418.075,6.421q.015,3.211.112,6.425Z",
    transform: "translate(-118.496 -256.273)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11871",
    "data-name": "Path 11871",
    d: "M286.882,353.164q3.684-1.75,7.474-3.251c2.516-1.024,5.055-1.994,7.623-2.884s5.153-1.738,7.778-2.469a72.887,72.887,0,0,1,7.966-1.861l.664-.108-.118.634c-.622,3.322-1.274,6.64-2.043,9.939.288-3.375.694-6.731,1.129-10.083l.546.526c-2.618.623-5.215,1.353-7.805,2.119s-5.167,1.589-7.739,2.426Z",
    transform: "translate(-96.959 -252.976)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9589",
    "data-name": "Group 9589",
    transform: "translate(91.154 71.584)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11872",
    "data-name": "Path 11872",
    d: "M214.4,328.122l.668,12.835.571,12.838.99,25.682.774,25.689.31,12.847.212,12.851-.669-12.835-.571-12.838-.988-25.682-.772-25.689-.31-12.847Z",
    transform: "translate(-205.958 -328.122)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11873",
    "data-name": "Path 11873",
    d: "M212.4,334.715a2.424,2.424,0,0,1-1.656,2.792,2.42,2.42,0,1,1-.952-4.723A2.423,2.423,0,0,1,212.4,334.715Zm0,0a1.941,1.941,0,0,0-2.516-1.472,1.958,1.958,0,0,0,.768,3.807,1.945,1.945,0,0,0,1.748-2.335Z",
    transform: "translate(-207.626 -326.978)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11874",
    "data-name": "Path 11874",
    d: "M213.1,347.064a2.424,2.424,0,0,1-1.656,2.792,2.42,2.42,0,1,1-.952-4.723A2.423,2.423,0,0,1,213.1,347.064Zm0,0a1.941,1.941,0,0,0-2.516-1.472,1.958,1.958,0,0,0,.768,3.807,1.943,1.943,0,0,0,1.748-2.335Z",
    transform: "translate(-207.452 -323.938)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11875",
    "data-name": "Path 11875",
    d: "M213.554,360.173a2.422,2.422,0,0,1-1.656,2.79,2.42,2.42,0,1,1-.952-4.723A2.425,2.425,0,0,1,213.554,360.173Zm0,0a1.943,1.943,0,0,0-2.516-1.473,1.958,1.958,0,0,0,.768,3.807,1.943,1.943,0,0,0,1.748-2.334Z",
    transform: "translate(-207.341 -320.71)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11876",
    "data-name": "Path 11876",
    d: "M214,373.281a2.424,2.424,0,0,1-1.656,2.792,2.421,2.421,0,1,1-.952-4.724A2.425,2.425,0,0,1,214,373.281Zm0,0a1.941,1.941,0,0,0-2.516-1.472,1.958,1.958,0,0,0,.768,3.807A1.945,1.945,0,0,0,214,373.281Z",
    transform: "translate(-207.23 -317.483)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11877",
    "data-name": "Path 11877",
    d: "M214.454,386.39a2.423,2.423,0,0,1-1.656,2.79,2.42,2.42,0,1,1-.953-4.723A2.424,2.424,0,0,1,214.454,386.39Zm0,0a1.943,1.943,0,0,0-2.516-1.473,1.958,1.958,0,0,0,.768,3.807,1.945,1.945,0,0,0,1.748-2.334Z",
    transform: "translate(-207.119 -314.256)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11878",
    "data-name": "Path 11878",
    d: "M214.9,399.5a2.422,2.422,0,0,1-1.656,2.79,2.42,2.42,0,1,1-.953-4.723A2.426,2.426,0,0,1,214.9,399.5Zm0,0a2,2,0,0,0-.965-1.327,1.983,1.983,0,0,0-1.552-.145,1.958,1.958,0,0,0,.768,3.807A1.945,1.945,0,0,0,214.9,399.5Z",
    transform: "translate(-207.009 -311.028)",
    opacity: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9593",
    "data-name": "Group 9593",
    transform: "translate(0 243.41)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3291",
    "data-name": "Rectangle 3291",
    width: 61.04,
    height: 7.133,
    transform: "translate(58.986 48.449) rotate(-16.86)",
    fill: "#ffc727"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3292",
    "data-name": "Rectangle 3292",
    width: 61.04,
    height: 7.133,
    transform: "translate(58.986 48.449) rotate(-16.86)",
    fill: "#fdaa3c",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3293",
    "data-name": "Rectangle 3293",
    width: 7.132,
    height: 10.594,
    transform: "translate(82.619 39.043) rotate(-17.644)",
    fill: "#fa9001"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9592",
    "data-name": "Group 9592"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11879",
    "data-name": "Path 11879",
    d: "M184.395,459.759,169.32,394.484l-45.5,10.787,22.4,63.616Z",
    transform: "translate(-123.821 -394.484)",
    fill: "#fa9001"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9591",
    "data-name": "Group 9591",
    transform: "translate(45.499)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11880",
    "data-name": "Path 11880",
    d: "M185.5,456.44l-10.1,3.319-15.074-65.275,14.521,3.457Z",
    transform: "translate(-160.331 -394.484)",
    fill: "#d87f07"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11881",
    "data-name": "Path 11881",
    d: "M185.5,456.44l-10.1,3.319-15.074-65.275,14.521,3.457Z",
    transform: "translate(-160.331 -394.484)",
    fill: "#d87f07",
    opacity: 0.2
  }))), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_659",
    "data-name": "Ellipse 659",
    cx: 7.745,
    cy: 7.745,
    r: 7.745,
    transform: "translate(110.693 26.414)",
    fill: "#fa9001"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9596",
    "data-name": "Group 9596",
    transform: "translate(189.352 243.385)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3294",
    "data-name": "Rectangle 3294",
    width: 7.132,
    height: 61.041,
    transform: "matrix(0.292, -0.956, 0.956, 0.292, 6.703, 37.415)",
    fill: "#ffc727"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3295",
    "data-name": "Rectangle 3295",
    width: 7.132,
    height: 61.041,
    transform: "matrix(0.292, -0.956, 0.956, 0.292, 6.703, 37.415)",
    fill: "#fdaa3c",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3296",
    "data-name": "Rectangle 3296",
    width: 10.594,
    height: 7.132,
    transform: "matrix(0.305, -0.952, 0.952, 0.305, 33.527, 46.876)",
    fill: "#fa9001"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9595",
    "data-name": "Group 9595",
    transform: "translate(55.454)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11882",
    "data-name": "Path 11882",
    d: "M328.357,459.707l15.213-65.243,45.476,10.884-22.539,63.568Z",
    transform: "translate(-318.269 -394.464)",
    fill: "#fa9001"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9594",
    "data-name": "Group 9594"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11883",
    "data-name": "Path 11883",
    d: "M320.262,456.367l10.088,3.341,15.213-65.243-14.528,3.427Z",
    transform: "translate(-320.262 -394.464)",
    fill: "#d87f07"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11884",
    "data-name": "Path 11884",
    d: "M320.262,456.367l10.088,3.341,15.213-65.243-14.528,3.427Z",
    transform: "translate(-320.262 -394.464)",
    fill: "#d87f07",
    opacity: 0.2
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_11885",
    "data-name": "Path 11885",
    d: "M275.764,423.264a7.745,7.745,0,1,0,7.761-7.728A7.746,7.746,0,0,0,275.764,423.264Z",
    transform: "translate(-275.764 -389.276)",
    fill: "#fa9001"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9598",
    "data-name": "Group 9598",
    transform: "translate(242.885 176.836)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9597",
    "data-name": "Group 9597"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11886",
    "data-name": "Path 11886",
    d: "M323.634,361.088c.182-.172,18.946-17.575,41.018-11.623,22.573,6.09,41.207,40.087,41.393,40.431l6.273-3.392c-.815-1.509-20.252-37.042-45.809-43.924-25.992-7.01-46.91,12.5-47.788,13.339Z",
    transform: "translate(-318.72 -341.063)",
    fill: "#ffc727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11887",
    "data-name": "Path 11887",
    d: "M323.634,361.088c.182-.172,18.946-17.575,41.018-11.623,22.573,6.09,41.207,40.087,41.393,40.431l6.273-3.392c-.815-1.509-20.252-37.042-45.809-43.924-25.992-7.01-46.91,12.5-47.788,13.339Z",
    transform: "translate(-318.72 -341.063)",
    fill: "#fdaa3c",
    opacity: 0.4
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_11888",
    "data-name": "Path 11888",
    d: "M383.091,416.07l13.515-7.136a28.533,28.533,0,0,1-3.127-10.491c-.3-4.941,1.66-6.678,3.823-7.82,4.736-2.5,7.561-1.509,9.491-.373,2.708,1.6,5.462,4.87,7.754,9.212l13.516-7.136c-3.7-7.006-8.241-12.133-13.5-15.237s-13.739-5.608-24.4.019c-8.307,4.385-12.548,12.293-11.941,22.263A44.178,44.178,0,0,0,383.091,416.07Z",
    transform: "translate(-304.084 -333.011)",
    fill: "#fa9001"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9599",
    "data-name": "Group 9599",
    transform: "translate(242.885 151.412)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11889",
    "data-name": "Path 11889",
    d: "M324.949,342.3c2.93-2.024,5.929-3.93,8.938-5.82s6.055-3.718,9.107-5.534c3.067-1.791,6.135-3.579,9.253-5.285l4.678-2.554c1.583-.813,3.143-1.662,4.746-2.441-1.459,1.023-2.958,1.977-4.435,2.967l-4.5,2.854c-3,1.9-6.054,3.717-9.107,5.532-3.068,1.79-6.136,3.579-9.254,5.284S328.139,340.715,324.949,342.3Z",
    transform: "translate(-317.186 -320.662)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11890",
    "data-name": "Path 11890",
    d: "M318.72,361.423c4.2,2.392,8.173,5.088,12.094,7.861,3.9,2.8,7.746,5.684,11.37,8.876-4.2-2.389-8.173-5.086-12.093-7.861C326.192,367.492,322.346,364.612,318.72,361.423Z",
    transform: "translate(-318.72 -310.626)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11891",
    "data-name": "Path 11891",
    d: "M324.249,358.545c3.238.983,6.425,2.095,9.606,3.225s6.334,2.325,9.485,3.534c3.139,1.236,6.277,2.475,9.38,3.8l4.653,2c1.534.708,3.084,1.376,4.6,2.12-1.623-.48-3.218-1.036-4.827-1.55L352.372,370c-3.185-1.118-6.336-2.325-9.484-3.535-3.139-1.237-6.277-2.476-9.38-3.806S327.3,360.008,324.249,358.545Z",
    transform: "translate(-317.359 -311.335)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11892",
    "data-name": "Path 11892",
    d: "M331.63,341.529c3.1-.806,6.23-1.478,9.359-2.13s6.272-1.234,9.416-1.8c3.15-.54,6.3-1.077,9.466-1.519l4.752-.658c1.591-.176,3.175-.393,4.773-.53-1.549.416-3.112.753-4.668,1.13l-4.691,1c-3.127.664-6.271,1.234-9.416,1.8-3.149.537-6.3,1.075-9.466,1.517S334.822,341.229,331.63,341.529Z",
    transform: "translate(-315.541 -317.159)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Speech_Bubble",
    "data-name": "Speech Bubble",
    transform: "translate(1267.53 -1083.906)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9622",
    "data-name": "Group 9622",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11945",
    "data-name": "Path 11945",
    d: "M362.98,249.946a30.611,30.611,0,0,1-5.238-16.915c0-21.43,23.533-38.8,52.544-38.8s52.52,17.375,52.52,38.8-23.51,38.8-52.52,38.8c-14.067,0-26.82-4.075-36.241-10.736l-18.1,4.6Z",
    transform: "translate(-355.946 -194.227)",
    fill: "#fff",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9621",
    "data-name": "Group 9621",
    transform: "translate(15.554 30.991)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11946",
    "data-name": "Path 11946",
    d: "M380.184,233.238v2.886H368.427V219.191h11.542v2.886h-8.251v4.078h7.131v2.672h-7.131v4.412Z",
    transform: "translate(-368.427 -219.071)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11947",
    "data-name": "Path 11947",
    d: "M379.929,236.125V219.191h7.488a4.814,4.814,0,0,1,2.158.489,5.613,5.613,0,0,1,1.7,1.289,6.042,6.042,0,0,1,1.12,1.812,5.457,5.457,0,0,1,.406,2.04,5.617,5.617,0,0,1-.824,2.992,4.714,4.714,0,0,1-2.229,1.944l3.864,6.368h-3.7l-3.457-5.677H383.22v5.677Zm3.291-8.563h4.126a1.736,1.736,0,0,0,.846-.214,2.153,2.153,0,0,0,.679-.584,2.864,2.864,0,0,0,.454-.87,3.349,3.349,0,0,0,.167-1.073,3.065,3.065,0,0,0-.191-1.1,2.858,2.858,0,0,0-.513-.87,2.326,2.326,0,0,0-.739-.573,1.926,1.926,0,0,0-.846-.2H383.22Z",
    transform: "translate(-365.595 -219.071)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11948",
    "data-name": "Path 11948",
    d: "M392.654,236.125V219.191h7.49a4.809,4.809,0,0,1,2.157.489,5.6,5.6,0,0,1,1.706,1.289,6.092,6.092,0,0,1,1.12,1.812,5.456,5.456,0,0,1,.4,2.04,5.616,5.616,0,0,1-.822,2.992,4.714,4.714,0,0,1-2.229,1.944l3.865,6.368h-3.7l-3.458-5.677h-3.243v5.677Zm3.293-8.563h4.125a1.733,1.733,0,0,0,.846-.214,2.144,2.144,0,0,0,.68-.584,2.889,2.889,0,0,0,.452-.87,3.349,3.349,0,0,0,.168-1.073,3.091,3.091,0,0,0-.191-1.1,2.909,2.909,0,0,0-.513-.87,2.326,2.326,0,0,0-.739-.573,1.931,1.931,0,0,0-.847-.2h-3.982Z",
    transform: "translate(-362.462 -219.071)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11949",
    "data-name": "Path 11949",
    d: "M412.81,236.267a7.7,7.7,0,0,1-3.375-.727,8.273,8.273,0,0,1-2.6-1.932,8.943,8.943,0,0,1-2.277-5.927,8.515,8.515,0,0,1,.631-3.244,8.94,8.94,0,0,1,1.741-2.742,8.319,8.319,0,0,1,2.636-1.9,7.831,7.831,0,0,1,3.315-.7,7.435,7.435,0,0,1,3.351.751,8.37,8.37,0,0,1,2.587,1.968,9.075,9.075,0,0,1,1.67,2.767,8.705,8.705,0,0,1,.6,3.148,8.578,8.578,0,0,1-.619,3.231,8.78,8.78,0,0,1-1.717,2.719,8.249,8.249,0,0,1-2.623,1.884A7.83,7.83,0,0,1,412.81,236.267Zm-4.914-8.585a6.794,6.794,0,0,0,.334,2.122,5.676,5.676,0,0,0,.966,1.813,4.8,4.8,0,0,0,1.55,1.264,4.8,4.8,0,0,0,4.2-.011,4.841,4.841,0,0,0,1.55-1.3,5.812,5.812,0,0,0,.953-1.826,6.782,6.782,0,0,0,.322-2.062,6.632,6.632,0,0,0-.345-2.122,5.9,5.9,0,0,0-.977-1.813,4.66,4.66,0,0,0-1.552-1.251,4.82,4.82,0,0,0-4.185.024,4.7,4.7,0,0,0-1.55,1.287,5.785,5.785,0,0,0-.942,1.813A6.745,6.745,0,0,0,407.9,227.681Z",
    transform: "translate(-359.531 -219.095)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11950",
    "data-name": "Path 11950",
    d: "M419.849,236.125V219.191h7.488a4.818,4.818,0,0,1,2.158.489,5.612,5.612,0,0,1,1.7,1.289,6.042,6.042,0,0,1,1.12,1.812,5.456,5.456,0,0,1,.406,2.04,5.617,5.617,0,0,1-.824,2.992,4.714,4.714,0,0,1-2.229,1.944l3.864,6.368h-3.7l-3.457-5.677H423.14v5.677Zm3.291-8.563h4.126a1.731,1.731,0,0,0,.845-.214,2.144,2.144,0,0,0,.68-.584,2.865,2.865,0,0,0,.454-.87,3.384,3.384,0,0,0,.167-1.073,3.065,3.065,0,0,0-.191-1.1,2.857,2.857,0,0,0-.513-.87,2.326,2.326,0,0,0-.739-.573,1.927,1.927,0,0,0-.847-.2H423.14Z",
    transform: "translate(-355.766 -219.071)",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("text", {
    id: "Oops_The_page_you_were_looking_for_doesn_t_exist",
    "data-name": "Oops! The page you were looking for doesn\\u2019t exist",
    transform: "translate(770 424)",
    fill: "#0f0f0f",
    fontSize: 24,
    fontFamily: "Montserrat-ExtraBold, Montserrat",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 23
  }, "Oops! The page you were looking "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 57
  }, "for doesn\u2019t exist")), /*#__PURE__*/React.createElement("text", {
    id: "Need_help_Give_us_a_call_on_1800_444_744",
    "data-name": "Need help? Give us a call on 1800 444 744",
    transform: "translate(770 582)",
    fill: "#6b6b6b",
    fontSize: 16,
    fontFamily: "Montserrat-SemiBold, Montserrat",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Need help? Give us a call on 1800 444 744")), /*#__PURE__*/React.createElement("g", {
    id: "Group_9632",
    "data-name": "Group 9632",
    transform: "translate(173 -57)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Click_here_to_go_to_the_homepage",
    "data-name": "Click here to go to the homepage",
    transform: "translate(597 587)",
    fill: "#fa9001",
    fontSize: 24,
    fontFamily: "Montserrat-Bold, Montserrat",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Click here to go to the homepage")), /*#__PURE__*/React.createElement("line", {
    id: "Line_521",
    "data-name": "Line 521",
    x2: 422,
    transform: "translate(597.5 598.5)",
    fill: "none",
    stroke: "#fa9001",
    strokeLinecap: "round",
    strokeWidth: 2
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.c29657570bb10152b560f6748d88512d.svg";
export { ForwardRef as ReactComponent };